export default __webpack_public_path__ + "img/binla_channel.068e243c.png";